import React from 'react';
import IconText from '@common/components/IconText'
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';
import { Height } from '@mui/icons-material';

function LogoItem({ logoItem, small, condition }) {
    const spanClass = logoItem?.span === 2 ? ' bs-features__item-logo--span-2' : '2'
    const sizeClass = small ? ' bs-features__item-logo--sm' : ''
    return (
        condition ?
            (<li className={`bs-features__item-logo2`} key={logoItem?.id}>
                <CloudinaryAdvancedImage imagePublicId={logoItem?.name} className='bs-features__item-mage' type="partner-logo" />
            </li>) :
            logoItem?.name.includes('Sedex_Member') ?
                (<li className={`bs-features__item-logo${spanClass}${sizeClass} bs-features__item-logo--lg`} key={logoItem?.id}>
                    <CloudinaryAdvancedImage imagePublicId={logoItem?.name} className='bs-features__item-mage' type="partner-logo" />
                </li>)
                : logoItem?.name.includes('Global_Recycled_Standard') ?
                    (<li className={`bs-features__item-logo${spanClass}${sizeClass}`} key={logoItem?.id} style={{ width: '8rem', marginLeft: '1rem' }}>
                        <CloudinaryAdvancedImage imagePublicId={logoItem?.name} className='bs-features__item-mage' type="partner-logo" />
                    </li>)
                    : (<li className={`bs-features__item-logo${spanClass}${sizeClass}`} key={logoItem?.id}>
                        <CloudinaryAdvancedImage imagePublicId={logoItem?.name} className='bs-features__item-mage' type="partner-logo" />
                    </li>)
    )
}

function Features({ data }) {
    return (
        <div className='bs-features'>
            <ul className='bs-features__list-wrap'>
                {data?.map((item) => {
                    const row1 = item?.certificates?.filter(c => !c.group || c.group === 1) ?? []
                    const row2 = item?.certificates?.filter(c => c.group === 2) ?? []
                    return (
                        <li className='bs-features__list-item' key={item?.id}>
                            <div className='bs-features__item'>
                                <div className='bs-features__item-title-wrap'>
                                    <IconText
                                        icon={item?.icon}
                                        title={item?.title}
                                        classname="bs-features__item-icon-text"
                                    />
                                    {(row1.length > 0 || row2.length > 0) && (
                                        <div className='bs-features__item-logo-wrap'>
                                            {row1.length > 0 && (
                                                <ul className='bs-features__item-logo-list2'>
                                                    {row1.map((logoItem) => {
                                                        return <LogoItem key={logoItem?.id} logoItem={logoItem} />
                                                    })}
                                                    {/* {row2.map((logoItem) => (
                                                        <LogoItem key={logoItem?.id} logoItem={logoItem} small />
                                                    ))} */}
                                                </ul>
                                            )}
                                            {row2.length > 0 && (
                                                <ul className='bs-features__item-logo-list bs-features__item-logo-list--row-2'>
                                                    {row2.map((logoItem) => (
                                                        logoItem?.id === 1 ?
                                                            (<LogoItem key={logoItem?.id} logoItem={logoItem} small condition={true} />)
                                                            : (<LogoItem key={logoItem?.id} logoItem={logoItem} small />)
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className='bs-features__item-desc-wrap'>
                                    <p className='bs-features__item-desc'>{item?.desc}</p>
                                </div>
                            </div>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default Features
